/**
 * TOC (Table of Contents) — basic toggle for ALL pages that have a TOC.
 * Runs on both brand and post single pages via global.js.
 *
 * Handles multiple TOC instances on the same page (e.g. brand pages have a
 * desktop sidebar with id="toc-content-xl" and a mobile inline TOC with
 * id="toc-content"). Each toggle button is initialised independently via
 * aria-controls → its paired nav.
 *
 * Advanced features (scroll tracking, active states, smooth scroll) live in
 * brand-single.js and only run where brand.js is enqueued.
 */
document.addEventListener('DOMContentLoaded', () => {
  const isMobile = () => window.innerWidth < 1280;

  document.querySelectorAll('.bfwt-brand-toc__toggle').forEach((tocToggle) => {
    const navId = tocToggle.getAttribute('aria-controls');
    const tocContent = navId ? document.getElementById(navId) : null;
    if (!tocContent) return;

    // ── Toggle button ────────────────────────────────────────────────────────
    tocToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isExpanded = tocToggle.getAttribute('aria-expanded') === 'true';
      tocToggle.setAttribute('aria-expanded', String(!isExpanded));
      tocContent.hidden = isExpanded;

      if (window.bfwt_trackEvent) {
        window.bfwt_trackEvent('toc_mobile_toggle', {
          opened: !isExpanded,
          event_category: 'navigation',
        });
      }
    });

    // ── Close dropdown after navigating to a section ────────────────────────
    tocContent.querySelectorAll('.bfwt-brand-toc__link').forEach((link) => {
      link.addEventListener('click', () => {
        if (tocToggle.closest('.bfwt-brand-toc-floating') || isMobile()) {
          tocToggle.setAttribute('aria-expanded', 'false');
          tocContent.hidden = true;
        }
      });
    });
  });

  // ── Close any open TOC on outside click ───────────────────────────────────
  document.addEventListener('click', (e) => {
    document
      .querySelectorAll('.bfwt-brand-toc__toggle[aria-expanded="true"]')
      .forEach((btn) => {
        if (btn.contains(e.target)) return;
        const navId = btn.getAttribute('aria-controls');
        const nav = navId ? document.getElementById(navId) : null;
        if (nav && !nav.contains(e.target)) {
          if (btn.closest('.bfwt-brand-toc-floating') || isMobile()) {
            btn.setAttribute('aria-expanded', 'false');
            nav.hidden = true;
          }
        }
      });
  });

  // ── Close open floating TOC on Escape key ─────────────────────────────────
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document
        .querySelectorAll('.bfwt-brand-toc__toggle[aria-expanded="true"]')
        .forEach((btn) => {
          const navId = btn.getAttribute('aria-controls');
          const nav = navId ? document.getElementById(navId) : null;
          btn.setAttribute('aria-expanded', 'false');
          if (nav) nav.hidden = true;
        });
    }
  });

  // ── Dynamic Header Stack Synchronisation ──────────────────────────────────
  // Measures the exact sticky header footprint (top offset + masthead height,
  // including announcement bar if present) and writes --header-stack to :root.
  function updateHeaderStack() {
    const masthead = document.getElementById('masthead');
    if (!masthead) return;
    const computed = window.getComputedStyle(masthead);
    const topVal = parseFloat(computed.top) || 20;
    const height = masthead.offsetHeight || 0;
    const stack = Math.round(topVal + height);
    if (stack > 0) {
      document.documentElement.style.setProperty('--header-stack', `${stack}px`);
    }
  }

  window.bfwt_updateHeaderStack = updateHeaderStack;
  updateHeaderStack();

  if (typeof ResizeObserver !== 'undefined') {
    const masthead = document.getElementById('masthead');
    if (masthead) {
      const ro = new ResizeObserver(() => {
        updateHeaderStack();
      });
      ro.observe(masthead);
    }
  }

  window.addEventListener('resize', updateHeaderStack, { passive: true });
});

